// extracted by mini-css-extract-plugin
module.exports = {"pulse":"BlackPackages_pulse__xs1nK","pulse-animation":"BlackPackages_pulse-animation__LK09s"};